import styled from 'styled-components/macro'

export const RootS = styled.div`
  display: flex;
  flex-direction: row;
`
